module.exports = {

    /**
     * Site default title
     */
    title: 'Go Med Crm',
}